export default "__VITE_ASSET__CV$XgWE6__"